module.exports = __webpack_public_path__ + "img/X-explore-with-friends.3a466ee7.jpg";